export function createRateCardModifierFormValue(modifier) {
    const type = modifier?.type || "percentage"
    const value = formatModifierValue(modifier, type)

    return {
        name: modifier?.name || "",
        type,
        scope: normalizeRateCardModifierScope(modifier?.scope),
        value,
        applyTo: modifier?.applyTo || "running",
    }
}

export function normalizeRateCardModifier(data) {
    const value = parseModifierValue(data?.value)
    const type = data?.type || "percentage"

    return {
        name: String(data?.name || "").trim(),
        type,
        scope: normalizeRateCardModifierScope(data?.scope),
        value: type === "percentage" ? roundTo(value / 100, 8) : value,
        applyTo: type === "percentage" ? data?.applyTo || "running" : "running",
    }
}

export function isRateCardModifierFormInvalid(data) {
    const name = String(data?.name || "").trim()
    if (!name || name.length > 60) return true

    const rawValue = String(data?.value ?? "").trim()
    if (!rawValue) return true
    return !Number.isFinite(parseModifierValue(rawValue))
}

export function normalizeRateCardModifierScope(scope) {
    if (!scope?.kind || scope.kind === "whole-regime") return { kind: "whole-regime", value: null }
    return { ...scope }
}

function parseModifierValue(value) {
    return Number(String(value ?? "").replace(/,/g, ""))
}

function formatModifierValue(modifier, type) {
    if (!modifier) return ""
    if (type === "percentage") return roundTo(Number(modifier.value ?? 0) * 100, 6).toString()
    return String(modifier.value ?? "")
}

// Percentages are held as decimals, and both /100 and *100 leave binary artifacts on about a
// tenth of two-decimal inputs: 7% stores as 0.07 and reads back as 7.000000000000001. Rounding
// both directions keeps an untouched modifier's value stable through an edit.
function roundTo(value, places) {
    const factor = 10 ** places
    return Math.round(value * factor) / factor
}
